<template>
    <v-dialog v-model="abrir" persistent max-width="70vw" scrollable>
        <v-card max-height="600px" :loading="loading">
            <v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
            
            <v-card-text>
            
                <v-data-table fixed-header :items="passagens" :headers="fields" :items-per-page="10">
                    <template v-slot:item.data="{ item }">
						{{mostrarData(item.data)}}
					</template>
                    <template v-slot:item.actions="{ item }">
                        <v-btn :disabled="item.grau == 1" text color="primary" @click.stop="editar(item)">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn :disabled="item.grau == 1" text color="primary" @click.stop="excluir(item)">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            
            </v-card-text>
            <v-divider>
            </v-divider>
            <v-card-actions>
                <v-spacer>
                </v-spacer>
                <v-btn small color="primary" @click.stop="fechar()">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    
    import { baseApiUrl, showError } from "@/config/global"
    import axios from 'axios'
    import metodos from '@/mixins/metodos.js'

	export default{
        name: "PassagensGrau",
        props: ['abrir', 'iniciado'],
        mixins:[metodos],

		data(){
			return {
                loading: false,
                cor: 'primary',
                passagens: [],
				fields: [
                    {text: 'Grau', value: 'grau', align: 'center', divider: true},
					{text: 'Data', value: 'data', align: 'center', divider: true},
                ],
			}
		},

		methods:{

			buscaPassagens(id){
                
				const url = `${baseApiUrl}/perfil/buscaPassagens.php?iniciado=${id}`

				axios.post(url, this.iniciado)
				.then(res => {
					if(res.data.codigo == '01'){
                        this.passagens = res.data.passagens
					}else{
                        showError(res.data.mensagem)
                    }
                })
                
                this.loading = false
            },
            
            fechar(){
                this.$emit('fechar')
            },
            
		},

        watch:{
            abrir(val){
                if(val){
                    if(this.passagens.length == 0){
                        this.buscaPassagens(this.iniciado)
                    }
                }
            }
        }
	}
</script>

<style scoped>


</style>